import * as React from 'react';
import { SelectBox, SelectBoxProps } from './SelectBox';

type Props = Omit<
  SelectBoxProps<string, string>,
  'allowCreateItems' | 'getNewItem' | 'getItemName' | 'getItemId' | 'items'
> & {
  items: string[];
};

export const SelectBoxSuggestText: React.FC<Props> = ({
  items,
  dataTest,
  ...other
}) => {
  return (
    <SelectBox<string, string>
      dataTest={dataTest}
      {...other}
      allowCreateItems
      items={items}
      getItemId={(i) => i}
      getItemName={(i) => i}
      getNewItem={(text) => text}
    />
  );
};
